export default "__VITE_ASSET__BgmO36dq__"